// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"b1ee69fb","684":"2a554caf"}[chunkId] + ".chunk.js";
};